import React, { useState, useEffect}  from 'react';
import "./oursites.scss";
import Grid from '@material-ui/core/Grid';
import axios from 'axios';

const OurSites = (props) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
  
    useEffect(() => {
        const fetchData = async () => {
          //setIsError(false)
            setIsLoading(true)
        try {
            const result = await axios(process.env.MET_OURSITES)
            setData(result.data.Oursites);
            setIsLoading(false)
        } catch (error) {
            setIsError(true);
            console.log(error);
        }
            //setIsLoading(false)
        }
        fetchData();
    },[])

    return (
        <React.Fragment>
            <section className="ourSites">
                <Grid container>
                    <Grid item xs={12}>
                    <div className="title">Our sites</div>
                    
                    <div className="links">
                    <ul>    
                        {data.map((result, index) => 
                            <li key={index} dangerouslySetInnerHTML={{__html: result.GovJEHtmlLinkUrl}} ></li>
                        )} 

{/* //                        <li><a title="Blog opens in new window" href="https://blog.gov.je/" target="_blank" rel="noreferrer">Blog</a></li> */}
                    </ul>  
                    </div>  
                    </Grid>
                </Grid>
            </section>
        </React.Fragment>
    )
}
export default OurSites;